import {FeaturesEnum} from './featuresFlagEnum';
import {ProductEnum} from './productEnum';

export const REJECTED_REANALYSIS_FEATURE_BY_HOST: Record<ProductEnum, FeaturesEnum> = {
	[ProductEnum.HAP]: FeaturesEnum.PORTAL_FEATURE_REJECTED_REANALYSIS_AUTOSOL_HAPVIDA,
	[ProductEnum.CCG]: FeaturesEnum.PORTAL_FEATURE_REJECTED_REANALYSIS_AUTOSOL_CCG,
	[ProductEnum.CLINIPAM]: FeaturesEnum.PORTAL_FEATURE_REJECTED_REANALYSIS_AUTOSOL_CLINIPAM,
	[ProductEnum.GNDI_MINAS]: FeaturesEnum.PORTAL_FEATURE_REJECTED_REANALYSIS_AUTOSOL_NDIMG,
	[ProductEnum.GNDI]: FeaturesEnum.PORTAL_FEATURE_REJECTED_REANALYSIS_AUTOSOL_NDISP,
	[ProductEnum.NOTREDAME_SAUDE]: FeaturesEnum.PORTAL_FEATURE_REJECTED_REANALYSIS_AUTOSOL_NOTREDAME,
};
